import { SubmitData } from '@shared/utils';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { usePlanningBreachStore } from './usePlanningBreachStore';

export interface UseHandleSubmitOptions {
  confirmationRoute: string;
  endpoint: string;
}

export const useHandleSubmit = ({
  confirmationRoute,
  endpoint,
}: UseHandleSubmitOptions) => {
  const navigate = useNavigate();
  const { update } = usePlanningBreachStore();

  return useMutation({
    mutationFn: (variables: { payload: any; isLoggedInUser: any }) =>
      SubmitData({ ...variables, endpoint }),
    onSuccess: (data) => {
      if ((data && data.case_reference) || data.slaText) {
        update('caseReferenceId', data.case_reference);
        update('slaText', data.slaText);
        update('confirmation', data);
        navigate(confirmationRoute);
      }
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(confirmationRoute);
    },
  });
};
